import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  MIN_LENGTH,
  PASSWORD_ERROR_CODES,
  codePointLength,
} from '../../utils/checkPassword';
import style from '../../style/components/signin/PasswordValidation.module.scss';

const PasswordValidation = ({
  nistPasswordV2,
  password,
  errors,
  rules,
  validated,
}) => {
  const { t } = useTranslation();

  if (!nistPasswordV2) {
    return (
      <div className={style.validation}>
        <h3>Password should contain:</h3>
        <ul>
          {rules.map((rule, index) => {
            const className = validated[index] ? style.green : style.red;
            const symbol = validated[index] ? '✓' : 'X';
            return (
              <li key={rule}>
                <span className={className}>{symbol}</span>
                &nbsp;
                {rule}
              </li>
            );
          })}
        </ul>
        <p>Password can&#39;t be common or easily guessable</p>
      </div>
    );
  }

  const minLengthSatisfied = codePointLength(password || '') >= MIN_LENGTH;
  const hasEmailError = errors.some(
    (e) => e.code === PASSWORD_ERROR_CODES.CONTAINS_EMAIL,
  );
  const hasNameError = errors.some(
    (e) => e.code === PASSWORD_ERROR_CODES.CONTAINS_NAME,
  );

  return (
    <div id="new-pass-guidance" className={`${style.validation} ${style.v2}`}>
      <div className={style.shouldContainSection}>
        <ul>
          <li
            data-testid="password-rule-min-length"
            data-satisfied={minLengthSatisfied}
          >
            <span className={minLengthSatisfied ? style.green : style.red}>
              {minLengthSatisfied ? '✓' : 'X'}
            </span>
            &nbsp;
            {t('password.change.validation.requirementMinLength', {
              min: MIN_LENGTH,
            })}
          </li>
        </ul>
      </div>
      <p className={style.helperText}>
        {t('password.change.validation.guidanceReuse')}
      </p>
      <p className={style.helperText}>
        {t('password.change.validation.guidancePhrase')}
      </p>
      <p className={style.helperText}>
        {t('password.change.validation.guidancePassphrase')}
      </p>
      {hasEmailError && (
        <p
          data-testid="password-error-contains-email"
          className={style.contextError}
          role="alert"
        >
          {t('password.change.validation.errorContainsEmail')}
        </p>
      )}
      {hasNameError && (
        <p
          data-testid="password-error-contains-name"
          className={style.contextError}
          role="alert"
        >
          {t('password.change.validation.errorContainsName')}
        </p>
      )}
    </div>
  );
};

PasswordValidation.propTypes = {
  nistPasswordV2: PropTypes.bool,
  password: PropTypes.string,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      params: PropTypes.object,
    }),
  ),
  rules: PropTypes.arrayOf(PropTypes.string),
  validated: PropTypes.arrayOf(PropTypes.bool),
};

PasswordValidation.defaultProps = {
  nistPasswordV2: false,
  password: '',
  errors: [],
  rules: [],
  validated: [],
};

export default PasswordValidation;
